__turbopack_context__.v({
  "followBtn": "sOrJrq_followBtn",
});
